import { makeStyles } from '@material-ui/core/styles';

export const useAlertMessageMobileStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    width: 60,
    height: 60,
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
  },
  subtitle: {
    marginTop: 10,
    fontSize: 16,
    fontWeight: 700,
  },
}));
